function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../../../locales/keys';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import __ from 'ramda/src/__';
import clone from 'ramda/src/clone';
import { formValidated } from '../../../../../reducers/actions/mobile.number.portability.actions';
var MobileNumberPortabilityController = /*#__PURE__*/function () {
  function MobileNumberPortabilityController($ngRedux, uiNotificationService, $timeout) {
    _classCallCheck(this, MobileNumberPortabilityController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CoreLocaleKeys: CoreLocaleKeys,
      LocaleKeys: LocaleKeys,
      onContinue: this.onContinue.bind(this),
      onEdit: this.onEdit.bind(this),
      showConfirmation: this.showConfirmation.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(MobileNumberPortabilityController, [{
    key: "$onInit",
    value: function $onInit() {
      this.disconnectRedux = this.connectRedux();
      this.setVars();
      this.fetchDataCodes();
      this.setConfig();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "connectRedux",
    value: function connectRedux() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(__, store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
        formValidated: formValidated
      };
      return this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "fetchDataCodes",
    value: function fetchDataCodes() {
      var _this2 = this;
      var metadataCodes = [MetadataConstants.codes.AddressCountry, MetadataConstants.codes.AddressStateProvinceRegion, MetadataConstants.codes.MnpServiceProviderConfiguration];
      metadataCodes.forEach(function (codeType) {
        if (!_this2.state.codeTypeLoaded(codeType)) {
          _this2.actions.fetchCodeTypes(codeType);
        }
      });
    }
  }, {
    key: "setVars",
    value: function setVars() {
      var _this3 = this;
      this.number = '';
      this.provider = '';
      this.isApproved = false;
      this.inventoryTypeId = '';
      this.selectedAttribute = {};
      this.formPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this3.formPopupApi = api;
        }
      };
      this.confirmPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this3.confirmPopupApi = api;
        }
      };
    }
  }, {
    key: "onEdit",
    value: function onEdit(attribute) {
      if (attribute) {
        this.inventoryTypeId = attribute.inventoryTypeId;
        this.selectedAttribute = attribute;
      }
      this.closeConfirmation();
      this.openForm();
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.closeForm();
      this.closeConfirmation();
    }
  }, {
    key: "onContinue",
    value: function onContinue(addressData, portabilityData) {
      this.addressData = addressData;
      this.portabilityData = portabilityData;
      this.mnpVerificationCallBack()(addressData, portabilityData, this.inventoryTypeId);
      this.closeForm();
    }
  }, {
    key: "showConfirmation",
    value: function showConfirmation(token, errorMessage) {
      this.isApproved = !!token;
      this.number = this.portabilityData.existingNumber;
      this.provider = this.portabilityData.providerLabel;
      this.mnpVerificationErrorMessage = errorMessage;
      this.closeForm();
      this.openConfirmation();
    }
  }, {
    key: "openConfirmation",
    value: function openConfirmation() {
      var _this4 = this;
      this.confirmationOpen = true;
      this.$timeout(function () {
        _this4.confirmPopupApi.open();
      });
    }
  }, {
    key: "closeConfirmation",
    value: function closeConfirmation() {
      this.confirmPopupApi.close();
      this.confirmationOpen = false;
    }
  }, {
    key: "openForm",
    value: function openForm() {
      var _this5 = this;
      this.formOpen = true;
      this.$timeout(function () {
        _this5.formPopupApi.open();
      });
    }
  }, {
    key: "closeForm",
    value: function closeForm() {
      this.formPopupApi.close();
      this.formOpen = false;
    }
  }, {
    key: "onAccept",
    value: function onAccept() {
      this.closeConfirmation();
      this.actions.formValidated();
      this.onVerificationComplete()(clone(this.addressData), clone(this.portabilityData));
    }
  }, {
    key: "setConfig",
    value: function setConfig() {
      this.popupConfig.onRegisterApi({
        api: {
          open: this.onEdit,
          showConfirmation: this.showConfirmation
        }
      });
    }
  }]);
}();
export default {
  template: require('./mobile.number.portability.template.html'),
  controller: MobileNumberPortabilityController,
  bindings: {
    popupConfig: '<',
    onVerificationComplete: '&',
    mnpVerificationCallBack: '&'
  }
};